var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingsLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.124,
    height: 16,
    viewBox: "0 0 15.124 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cog",
    transform: "translate(-1.287 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M13.983,11.813a2.934,2.934,0,1,0,2.934,2.934,2.934,2.934,0,0,0-2.934-2.934Zm0,4.8a1.867,1.867,0,1,1,1.867-1.867A1.867,1.867,0,0,1,13.983,16.613Z",
    transform: "translate(-5.134 -5.621)",
    fill: "#0d3148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M16.167,11.336l-1.059-.872a6.436,6.436,0,0,0,0-2.678l1.059-.872a.665.665,0,0,0,.154-.848L15.233,4.184a.665.665,0,0,0-.811-.291l-1.285.482a6.4,6.4,0,0,0-2.318-1.34l-.226-1.353a.665.665,0,0,0-.658-.557H7.762a.665.665,0,0,0-.658.557L6.879,3.035a6.4,6.4,0,0,0-2.318,1.34L3.275,3.893a.665.665,0,0,0-.811.291L1.377,6.066a.665.665,0,0,0,.154.848l1.059.872a6.436,6.436,0,0,0,0,2.678l-1.059.872a.665.665,0,0,0-.154.848l1.087,1.883a.665.665,0,0,0,.811.291l1.285-.482a6.4,6.4,0,0,0,2.318,1.34L7.1,16.568a.665.665,0,0,0,.658.557H9.936a.665.665,0,0,0,.658-.557l.226-1.353a6.4,6.4,0,0,0,2.318-1.34l1.286.482a.665.665,0,0,0,.811-.291l1.087-1.883a.665.665,0,0,0-.153-.848Zm-1.688,1.9-1.6-.6-.243.245a5.332,5.332,0,0,1-2.421,1.4l-.333.088L9.6,16.058H8.1L7.819,14.37l-.333-.088a5.332,5.332,0,0,1-2.421-1.4l-.243-.245-1.6.6-.749-1.3,1.321-1.088-.09-.332a5.363,5.363,0,0,1,0-2.8l.09-.332L2.47,6.306l.748-1.3,1.6.6.243-.245a5.332,5.332,0,0,1,2.421-1.4l.333-.088L8.1,2.192H9.6L9.879,3.88l.333.088a5.332,5.332,0,0,1,2.421,1.4l.243.245,1.6-.6.748,1.3L13.906,7.394l.09.332a5.363,5.363,0,0,1,0,2.8l-.09.332,1.321,1.088Z",
    fill: "#0d3148"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings_light.618bbcf95d77c3a67c35a0ceaac14426.svg";